import { applyKeyframe, mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css, keyframes } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

// Widths (px) the caption changes layout at. The design system ships no breakpoint tokens, so the
// hero owns the widths it responds to.
const BREAKPOINT_M = 768;
const BREAKPOINT_XL = 1440;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const caption = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column-reverse;
  gap: var(${spacing.md});
  width: var(--width);
  margin: 0 auto;
  padding: var(${spacing.md}) 0;

  ${mediaQuery(
    { min: BREAKPOINT_M },
    css`
      flex-direction: row;
      padding: var(${spacing.md}) var(${spacing.xxl});
    `,
  )};

  ${mediaQuery(
    { min: BREAKPOINT_XL },
    css`
      width: 100%;
    `,
  )};
`;

export const cta = css`
  /* Full-width CTA on mobile; sizes to its content from the M breakpoint up. */
  width: 100%;

  & > a {
    width: calc(100% - (var(${spacing.xl}) * 2));
    margin: 0 var(${spacing.xl});
  }

  ${mediaQuery(
    { min: BREAKPOINT_M },
    css`
      width: auto;

      & > a {
        width: auto;
        margin: 0;
      }
    `,
  )};
`;

export const textBlock = css`
  animation: ${applyKeyframe(fadeIn)} 500ms ease;
  text-align: center;
  width: 100%;

  ${mediaQuery(
    { min: BREAKPOINT_M },
    css`
      width: auto;
      text-align: left;
    `,
  )};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const paragraph = css`
  margin: 0 0 var(${spacing.sm}) 0;
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.default});
`;

export const terms = css`
  margin: 0;
  color: var(${colors.content.tertiary});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
`;

// Holds the height of one terms line without showing anything, so switching between a slide that
// has T&Cs and one that doesn't no longer changes the carousel's height. `white-space: pre` keeps
// the space from collapsing, so the empty line still has a full line box.
export const termsPlaceholder = css`
  visibility: hidden;
  white-space: pre;
`;
